module.exports = __webpack_public_path__ + "static/media/new-york-city-gets-its-domain-name.4ac5021c.md";